<template>
    <component :is="tagName" :class="classes">
        <div>
            <vl-loader />
            <div class="kl-ol-map-loader__title">
                <slot>
                    {{ title }}
                </slot>
            </div>
        </div>
    </component>
</template>

<script src="./kl-ol-map-loader.ts"></script>
